import * as contextActions from '../actions/context.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface ContextState {
  contextList?: any;
  selectedInstitution?: any;
  selectedSystem?: any;
  contextSaveSuccess?: boolean;
}

const initialState = {
  contextList: null,
  selectedInstitution: null,
  selectedSystem: null,
  contextSaveSuccess: null
};

export const contextReducer = (state = initialState, action) => {
  switch (action.type) {
    case contextActions.GET_CONTEXT_LIST:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case contextActions.GET_CONTEXT_LIST_SUCCESS:
      return {
        ...state,
        contextList: action.payload,
        loading: false,
        loaded: true,
      };
    case contextActions.GET_CONTEXT_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: false,
      };
    case contextActions.SET_SYSTEM_CONTEXT:
      return {
        ...state,
        selectedSystem: action.payload.context,
        selectedInstitution: null,
      };
    case contextActions.SET_INSTITUTION_CONTEXT:
      return {
        ...state,
        selectedInstitution: action.payload.context,
        selectedSystem: null,
      };
    case contextActions.SAVE_CONTEXT:
      return {
        ...state,
        contextSaveSuccess: null
      };
    case contextActions.SAVE_CONTEXT_SUCCESS:
      const contextList = { ...state.contextList };
      contextList.institutionId = action.payload.institutionId;
      contextList.systemId = action.payload.systemId;
      return {
        ...state,
        contextList: contextList,
        contextSaveSuccess: true
      };
    case contextActions.SAVE_CONTEXT_FAIL:
      return {
        ...state,
        error: action.payload,
        contextSaveSuccess: false
      };
    case contextActions.RESET_SAVE_STATUS:
      return {
        ...state,
        contextSaveSuccess: null
      };
    default:
      return state;
  }
};

export const getContextState = createFeatureSelector<ContextState>('contextReducer');

export const getContextList = (state: ContextState) => state.contextList;
export const getSelectedInstitution = (state: ContextState) => state.selectedInstitution;
export const getContextSaveSuccess = (state: ContextState) => state.contextSaveSuccess;
export const getSelectedSystem = (state: ContextState) => state.selectedSystem;
